import BaseService from '@/services/BaseService';

class ProductService extends BaseService {
    createProduct = (data) => this.post('/create-product', data);

    updateProduct = (data, id) => this.post(`/edit-product/${id}`, data);

    getTreeCategoryList = () => this.get('/category-tree-view');

    getProductListOptions = (data) => this.post('/sort-product-view', data || {});

    getTableHeaders = (data) => this.post('/table-headers-view', data || {});

    viewProduct = (id) => this.get(`/view-product/${id}`);

    getProductList = (data) => this.post(
        `/view-products?page=${data.page}&per_page=${data.per_page}`,
        data || {},
    );

    changeProductStatus = (data) => this.post('/update-product-status', data);

    addProductsToCategories = (data) => this.post('/add-products-to-categories', data);

    getUnitList = () => this.get('/get-unit-list');

    getMaterialTypeList = () => this.get('/get-material-type-list');

    getCutLengthList = () => this.get('/get-cut-length-list');

    exportProducts = (data) => this.post('/export-products', data);
}

export default new ProductService();
